import DiscordIcon from '../icons/DiscordIcon'

export default function DiscordButton() {
  return (
    <a
      href="https://discord.gg/nJEvKAkkrZ"
      target="_blank"
      rel="noopener noreferrer"
      className="button-link discord"
    >
      <DiscordIcon /> Discord
    </a>
  )
}
